import { useQueryClient } from '@tanstack/react-query'
import { FilterIdentifier } from 'models/saved_view'
import { toast } from 'react-toastify'
import useApiService from 'services/api'
import { FilterStore } from '../FilterStore'
import { SavedFilterFormData, SavedFilterModal } from './SavedFilterModal'

interface CreateSavedFilterModalProps {
  show: boolean
  handleClose: () => void
  identifier: FilterIdentifier
  filterStore: FilterStore
  onFilterCreated?: () => void
}

export function CreateSavedFilterModal({
  show,
  handleClose,
  identifier,
  filterStore,
  onFilterCreated,
}: CreateSavedFilterModalProps) {
  const api = useApiService()
  const queryClient = useQueryClient()

  const { valueFilters, rangeFilters, zipCodeFilter, search, criteria } =
    filterStore()

  const handleSubmitSuccess = () => {
    toast.success('Filter saved!')
    onFilterCreated?.()
  }

  const createFilter = async (values: SavedFilterFormData) => {
    const filters = {
      valueFilters,
      rangeFilters,
      zipCodeFilter,
      search,
      criteria,
    }

    await api.saveFilters({
      identifier,
      name: values.name,
      shared: values.shared,
      payload: filters,
    })

    await queryClient.invalidateQueries({
      queryKey: ['saved_filters', identifier],
    })

    await queryClient.invalidateQueries({
      queryKey: ['saved-views/'],
    })
  }

  return (
    <SavedFilterModal
      show={show}
      handleClose={handleClose}
      onSubmitSuccess={handleSubmitSuccess}
      confirmButtonText="Save"
      submitApiAction={createFilter}
      title="Save Filter"
      description="Create a new filter to save this view, which includes both filters and any search terms."
    />
  )
}
